var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0 ma-0 mainContainer"},[_c('v-row',{class:_vm.justifyClass},[_c('v-col',{staticClass:"mainColumn pa-0"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }